export default "__VITE_ASSET__29df063c__"